import request from "../../utils/request.js";

const roomBksApi = {
  /**
   * 查询用户信息
   * @param {Object} parameter
   */
  pageUserBase(parameter) {
    return request.post("/platform-room/bks/room/pageUserBase", parameter);
  },
  /**
   * 查询管家用户信息
   * @param {Object} parameter
   */
  pageKeeprUserBase(parameter) {
    return request.post("/platform-room/bks/room/pageKeeprUserBase", parameter);
  },
  /**
   * 房源信息查询
   * @param {Object} parameter
   */
  pageHouseInfo(parameter) {
    return request.post("/platform-room/bks/room/pageHouseInfo", parameter);
  },
  /**
   * 分组查询房源信息
   * @param {Object} parameter
   */
  pageHouseInfoGroup(parameter) {
    return request.post(
      "/platform-room/bks/room/pageHouseInfoGroup",
      parameter
    );
  },
  /**
   * 上传房源信息
   * @param {Object} parameter
   */
  saveUploadHouseInfo(parameter) {
    return request.post(
      "/platform-room/bks/room/saveUploadHouseInfo",
      parameter
    );
  },
  /**
   * 房源上下架
   * @param {Object} parameter
   */
  saveUpDownHouseInfo(parameter) {
    return request.post(
      "/platform-room/bks/room/saveUpDownHouseInfo",
      parameter
    );
  },
  /**
   * 房源启停用
   * @param {Object} parameter
   */
  saveDisableEnableHouseInfo(parameter) {
    return request.post(
      "/platform-room/bks/room/saveDisableEnableHouseInfo",
      parameter
    );
  },
  /**
   * 查询房源收藏记录数量
   * @param {Object} parameter
   */
  pageHouseCollectGroup(parameter) {
    return request.post(
      "/platform-room/bks/room/pageHouseCollectGroup",
      parameter
    );
  },
  /**
   * 编辑房源信息
   * @param {Object} parameter
   */
  modifyHouseInfo(parameter) {
    return request.post("/platform-room/bks/room/modifyHouseInfo", parameter);
  },
  /**
   * 根据房源编号获取房源信息
   * @param {Object} parameter
   */
  findHouseInfoByHouseNo(parameter) {
    return request.get(
      "/platform-room/bks/room/findHouseInfoByHouseNo",
      parameter
    );
  },
  /**
   * 获取oss配置信息
   * @param {Object} parameter
   */
  findOssConfiguration(parameter) {
    return request.get(
      "/platform-room/bks/room/findOssConfiguration",
      parameter
    );
  },
  /**
   * 获取房源信息中相关分类的数据信息
   */
  findHouseKindData() {
    return request.get("/platform-room/bks/room/findHouseKindData");
  },

  /**
   * 查询管家信息
   * @param {Object} parameter
   */
  findKeeperHelpDto(parameter) {
    return request.get("/platform-room/bks/room/findKeeperHelpDto", parameter);
  },
  /**
   * 房源分配管家
   * @param {Object} parameter
   */
  saveHouseKeeper(parameter) {
    return request.post("/platform-room/bks/room/saveHouseKeeper", parameter);
  },
  /**
   * 查询管家商户关系信息
   * @param {Object} parameter
   */
  pageHouseMerchantKeeper(parameter) {
    return request.post(
      "/platform-room/bks/room/pageHouseMerchantKeeper",
      parameter
    );
  },
  /**
   * 添加管家商户关系
   * @param {Object} parameter
   */
  saveHouseMerchantKeeper(parameter) {
    return request.post(
      "/platform-room/bks/room/saveHouseMerchantKeeper",
      parameter
    );
  },
  /**
   * 删除管家商户关系
   * @param {Object} parameter
   */
  deleteKeeper(parameter) {
    return request.get("/platform-room/bks/room/deleteKeeper", parameter);
  },
  /**
   * 房源分配房东
   * @param {Object} parameter
   */
  saveHouseOwner(parameter) {
    return request.post("/platform-room/bks/room/saveHouseOwner", parameter);
  },
  /**
   * 删除房源房东关系
   * @param {Object} parameter
   */
  deleteHouseOwner(parameter) {
    return request.get("/platform-room/bks/room/deleteHouseOwner", parameter);
  },
  /**
   * 查询预约看房信息
   * @param {Object} parameter
   */
  pageHouseMakeRecord(parameter) {
    return request.post(
      "/platform-room/bks/room/pageHouseMakeRecord",
      parameter
    );
  },

  /**
   * 查询预约看房反馈信息
   * @param {Object} parameter
   */
  listHouseMakeReplyByMakeNo(parameter) {
    return request.get(
      "/platform-room/bks/room/listHouseMakeReplyByMakeNo",
      parameter
    );
  },

  /**
   * 添加反馈信息
   * @param {Object} parameter
   */
  saveHouseMakeReply(parameter) {
    return request.post(
      "/platform-room/bks/room/saveHouseMakeReply",
      parameter
    );
  },

  /**
   * 查询用户租约信息
   * @param {Object} parameter
   */
  pageHouseUserLease(parameter) {
    return request.post(
      "/platform-room/bks/room/pageHouseUserLease",
      parameter
    );
  },
  /**
   * 小区信息查询
   * @param {Object} parameter
   */
  pageHouseCommunity(parameter) {
    return request.post(
      "/platform-room/bks/room/pageHouseCommunity",
      parameter
    );
  },
  /**
   * 保存商户常用(热门)小区
   * @param {Object} parameter
   */
  saveMerchantHotCommunity(parameter) {
    return request.post(
        "/platform-room/bks/room/saveMerchantHotCommunity",
        parameter
    );
  },
  /**
   * 保存小区信息
   * @param {Object} parameter
   */
  saveHouseCommunity(parameter) {
    return request.post(
      "/platform-room/bks/room/saveHouseCommunity",
      parameter
    );
  },
  /**
   * 编辑小区信息
   * @param {Object} parameter
   */
  modifyHouseCommunity(parameter) {
    return request.post(
      "/platform-room/bks/room/modifyHouseCommunity",
      parameter
    );
  },
  /**
   * 删除小区信息
   * @param {Object} parameter
   */
  removeHouseCommunity(parameter) {
    return request.get(
      "/platform-room/bks/room/removeHouseCommunity",
      parameter
    );
  },
  /**
   * 查询小区地图分布
   * @param {Object} parameter
   */
  listCommunityMarker(parameter) {
    return request.post(
      "/platform-room/bks/room/listCommunityMarker",
      parameter
    );
  },
  /**
   * 商户信息查询
   * @param {Object} parameter
   */
  pageMerchantInfo(parameter) {
    return request.post("/platform-room/bks/room/pageMerchantInfo", parameter);
  },
  /**
   * 获取商户信息
   * @param {Object} parameter
   */
  findMerchantBaseByMerchantNo(parameter) {
    return request.get(
      "/platform-room/bks/room/findMerchantBaseByMerchantNo",
      parameter
    );
  },
  /**
   * 保存商户信息(基本信息，账户，认证信息)
   * @param {Object} parameter
   */
  saveMerchantAllInfo(parameter) {
    return request.post(
      "/platform-room/bks/room/saveMerchantAllInfo",
      parameter
    );
  },
  /**
   * 保存商户信息收款账户
   * @param {Object} parameter
   */
  saveMerchantAccount(parameter) {
    return request.post(
      "/platform-room/bks/room/saveMerchantAccount",
      parameter
    );
  },
  /**
   * 获取商户收款账户信息
   * @param {Object} parameter
   */
  findMerchantAccoutByMerchantNo(parameter) {
    return request.get(
      "/platform-room/bks/room/findMerchantAccoutByMerchantNo",
      parameter
    );
  },
  /**
   * 商户认证(人工)
   * @param {Object} parameter
   */
  saveAuditMerchant(parameter) {
    return request.post("/platform-room/bks/room/saveAuditMerchant", parameter);
  },
  /**
   * 查询商户绑定的用户信息
   * @param {Object} parameter
   */
  listMerchantBindUserByMerchantNo(parameter) {
    return request.get(
      "/platform-room/bks/room/listMerchantBindUserByMerchantNo",
      parameter
    );
  },
  /**
   * 商户解绑/绑定用户
   * @param {Object} parameter
   */
  unBindMerchantUser(parameter) {
    return request.post(
      "/platform-room/bks/room/unBindMerchantUser",
      parameter
    );
  },
  /**
   * 设置商户房源信息是否外显
   * @param {Object} parameter
   */
  settingMerchantShow(parameter) {
    return request.get(
      "/platform-room/bks/room/settingMerchantShow",
      parameter
    );
  },
  /**
   * 设置商户停用/启用
   * @param {Object} parameter
   */
  settingMerchantDisable(parameter) {
    return request.get(
      "/platform-room/bks/room/settingMerchantDisable",
      parameter
    );
  },
  /**
   * app版本信息查询
   * @param {Object} parameter
   */
  pageAppVersion(parameter) {
    return request.post("/platform-room/bks/room/pageAppVersion", parameter);
  },
  /**
   * 添加app版本信息
   * @param {Object} parameter
   */
  saveAppVersion(parameter) {
    return request.post("/platform-room/bks/room/saveAppVersion", parameter);
  },
  /**
   * 编辑app版本信息
   * @param {Object} parameter
   */
  modifyAppVersion(parameter) {
    return request.post("/platform-room/bks/room/modifyAppVersion", parameter);
  },
  /**
   * 更新app版本状态
   * @param {Object} parameter
   */
  modifyAppVersionStaById(parameter) {
    return request.get(
      "/platform-room/bks/room/modifyAppVersionStaById",
      parameter
    );
  },
  /**
   * 删除app版本信息
   * @param {Object} parameter
   */
  deleteAppVersionStaById(parameter) {
    return request.get(
      "/platform-room/bks/room/deleteAppVersionStaById",
      parameter
    );
  },
  /**
   * 验证码记录查询
   * @param {Object} parameter
   */
  pageEdmVerify(parameter) {
    return request.post("/platform-room/bks/room/pageEdmVerify", parameter);
  },
  /**
   * 更改验证码状态
   * @param {Object} parameter
   */
  modifyEdmVerifyStaByVerifyNo(parameter) {
    return request.get(
      "/platform-room/bks/room/modifyEdmVerifyStaByVerifyNo",
      parameter
    );
  },
  /**
   * 编辑用户基本信息
   * @param {Object} parameter
   */
  changeUserInfo(parameter) {
    return request.post("/platform-room/bks/room/changeUserInfo", parameter);
  },
  /**
   * 查询商家合同模板
   * @param {Object} parameter
   */
  pageMerchantContractTemplate(parameter) {
    return request.post(
      "/platform-room/bks/room/pageMerchantContractTemplate",
      parameter
    );
  },
  /**
   * 编辑商家合同模板
   * @param {Object} parameter
   */
  modifyMerchantContractTemplate(parameter) {
    return request.post(
      "/platform-room/bks/room/modifyMerchantContractTemplate",
      parameter
    );
  },
  /**
   * 删除商家合同模板信息
   * @param {Object} parameter
   */
  removeMerchantContractTemplate(parameter) {
    return request.post(
      "/platform-room/bks/room/removeMerchantContractTemplate",
      parameter
    );
  },
  /**
   * 获取创建模版的地址
   * @param {Object} parameter
   */
  getCreateTempatePageUrl(parameter) {
    return request.get(
      "/platform-room/bks/room/getCreateTempatePageUrl",
      parameter
    );
  },
  /**
   * 获取编辑模版的地址
   * @param {Object} parameter
   */
  getModifyTempatePageUrl(parameter) {
    return request.get(
      "/platform-room/bks/room/getModifyTempatePageUrl",
      parameter
    );
  },
  /**
   * 查询商户订单信息
   * @param {Object} parameter
   */
  pageMerchantOrder(parameter) {
    return request.post("/platform-room/bks/room/pageMerchantOrder", parameter);
  },
  /**
   * 查询商户合同记录
   * @param {Object} parameter
   */
  pageMerchantContract(parameter) {
    return request.post(
      "/platform-room/bks/room/pageMerchantContract",
      parameter
    );
  },
  /**
   * 查询合同套餐配置信息(分页)
   * @param {Object} parameter
   */
  pageContractGoodsBase(parameter) {
    return request.post(
      "/platform-room/bks/room/pageContractGoodsBase",
      parameter
    );
  },
  /**
   * 查询合同套餐配置信息
   * @param {Object} parameter
   */
  listContractGoodsBase(parameter) {
    return request.post(
      "/platform-room/bks/room/listContractGoodsBase",
      parameter
    );
  },
  /**
   * 保存合同套餐配置信息
   * @param {Object} parameter
   */
  saveContractGoodsBase(parameter) {
    return request.post(
      "/platform-room/bks/room/saveContractGoodsBase",
      parameter
    );
  },
  /**
   * 编辑合同套餐配置信息
   * @param {Object} parameter
   */
  modifyContractGoodsBase(parameter) {
    return request.post(
      "/platform-room/bks/room/modifyContractGoodsBase",
      parameter
    );
  },
  /**
   * 删除合同套餐配置信息
   * @param {Object} parameter
   */
  removeContractGoodsBase(parameter) {
    return request.get(
      "/platform-room/bks/room/removeContractGoodsBase",
      parameter
    );
  },
  /**
   * 商户在线下单
   * @param {Object} parameter
   */
  onlineMerchantOrder(parameter) {
    return request.post(
      "/platform-room/bks/room/onlineMerchantOrder",
      parameter
    );
  },
  /**
   * 查询支付结果
   * @param {Object} parameter
   */
  alipayOrderQuery(parameter) {
    return request.get("/platform-room/alipayOrderQuery", parameter);
  },
  /**
   * 编辑租约信息
   * @param {Object} parameter
   */
  modifyHouseUserLease(parameter) {
    return request.post(
      "/platform-room/bks/room/modifyHouseUserLease",
      parameter
    );
  },
  /**
   * 商户后台创建租约(前置校验-校验租客信息、电子签章相关信息
   * @param {Object} parameter
   */
  merchantCreateLeasePreCheck(parameter) {
    return request.post("/platform-room/bks/room/merchantCreateLeasePreCheck", parameter);
  },
  /**
   * 个人实名认证验证码验证
   * @param {Object} parameter
   */
  personalAuthVcodeVerify(parameter) {
    return request.post(
      "/platform-room/bks/room/personalAuthVcodeVerify",
      parameter
    );
  },
  /**
   * 设置商户自动签授权书
   * @param {Object} parameter 
   * @returns 
   */
   settingMerchantSignAuthFile(parameter) {
    return request.post(
      "/platform-room/bks/room/settingMerchantSignAuthFile",
      parameter
    );
  },
  /**
   * 商户后台创建租约
   * @param {Object} parameter
   */
  merchantCreateLease(parameter) {
    return request.post(
      "/platform-room/bks/room/merchantCreateLease",
      parameter
    );
  },
  /**
   * 重新发送短信
   * @param {Object} parameter
   */
  retrySendSignSms(parameter) {
    return request.post(
        "/platform-room/bks/room/retrySendSignSms",
        parameter
    );
  },
  /**
   * 重新发送短信
   * @param {Object} parameter
   */
  findSendSmsByLeaseNo(parameter) {
    return request.post(
        "/platform-room/bks/room/findSendSmsByLeaseNo",
        parameter
    );
  },
  /**
   * 获取签约地址
   * @param {Object} parameter
   */
  findSignContractUrl(parameter) {
    return request.get(
      "/platform-room/bks/room/findSignContractUrl",
      parameter
    );
  },
  /**
   * 下载合同文件
   * @param {Object} parameter
   */
  downloadContract(parameter, fileName) {
    return request.export(
      "/platform-room/bks/room/downloadContract",
      fileName,
      parameter
    );
  },
  /**
   * 获取预览合同URL
   * @param {Object} parameter
   */
  getContractPreviewURL(parameter) {
    return request.get(
      "/platform-room/bks/room/getContractPreviewURL",
      parameter
    );
  },
  /**
   * 获取首页展示数据
   * @param {Object} parameter
   */
  findHomeData(parameter) {
    return request.get("/platform-room/bks/room/findHomeData", parameter);
  }
};

export default roomBksApi;
